// label = 製作標籤（不是檢核清單，是備料批次＋標籤列印）
export const SOP_STAGES = ["open", "prep", "close", "label"];

// 這些階段共用清單、不分內外場
export const SOP_SHARED_STAGES = ["prep", "label"];
export const SOP_POSITIONS = ["outdoor", "indoor"];

const LAST_EMPLOYEE_KEY = "sop_last_employee";

export const getSopDateKey = (date = new Date()) =>
  [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("");

// 檢核頁查詢用的日期字串（YYYY-MM-DD，同後端 /sop 的 date 參數）
export const formatSopDate = (date = new Date()) =>
  [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");

// 前後移動 N 天；不能超過今天（回傳 null 代表「今天」）
export const shiftSopDate = (dateText, days, today = new Date()) => {
  const todayText = formatSopDate(today);
  const [year, month, day] = (dateText || todayText).split("-").map(Number);
  const next = formatSopDate(new Date(year, month - 1, day + days));
  return next >= todayText ? null : next;
};

// 只記住「當天」最後選過的人員，隔天自動失效
export const readLastSopEmployeeId = (date = new Date()) => {
  try {
    const raw = localStorage.getItem(LAST_EMPLOYEE_KEY);
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.date !== getSopDateKey(date)) return "";
    return parsed.employee_id ? String(parsed.employee_id) : "";
  } catch {
    return "";
  }
};

export const writeLastSopEmployeeId = (employeeId, date = new Date()) => {
  if (!employeeId) return;
  try {
    localStorage.setItem(
      LAST_EMPLOYEE_KEY,
      JSON.stringify({
        date: getSopDateKey(date),
        employee_id: String(employeeId),
      })
    );
  } catch {
    /* localStorage 不可用時略過 */
  }
};

// 記住的人員必須仍在今日班表中才會自動帶入
export const pickRememberedEmployeeId = (employees = [], date = new Date()) => {
  const remembered = readLastSopEmployeeId(date);
  if (!remembered) return "";
  return employees.some(
    (employee) => String(employee.employee_id) === remembered
  )
    ? remembered
    : "";
};

export const getDefaultSopStage = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 12) return "open";
  if (hour < 18) return "prep";
  return "close";
};

export const getAccountPositions = (account = "") => {
  switch (String(account).trim().toUpperCase()) {
    case "POS3":
      return ["indoor"];
    default:
      return [...SOP_POSITIONS];
  }
};

export const resolveAllowedPositions = (account, configuredPositions) => {
  const accountPositions = getAccountPositions(account);
  if (!Array.isArray(configuredPositions)) return accountPositions;

  const configured = configuredPositions.filter((position) =>
    SOP_POSITIONS.includes(position)
  );
  const allowed = accountPositions.filter((position) =>
    configured.includes(position)
  );

  return allowed.length ? allowed : accountPositions;
};

export const resolveDefaultPosition = (
  account,
  configuredDefault,
  configuredPositions
) => {
  const allowed = resolveAllowedPositions(account, configuredPositions);
  if (allowed.includes(configuredDefault)) return configuredDefault;
  // POS1 是結帳台：可切內場，但預設外場
  if (String(account).trim().toUpperCase() === "POS1" && allowed.includes("outdoor")) {
    return "outdoor";
  }
  return allowed.includes("indoor") ? "indoor" : allowed[0];
};
